import React from "react";
import {CartPlus} from "mdi-material-ui";

export default function StockIn(props) {
    return (
        <CartPlus className={props.className} />
    );
};
